import { render } from "./RoundImg-LTI.vue?vue&type=template&id=2fd775fc"
import script from "./RoundImg-LTI.vue?vue&type=script&lang=js"
export * from "./RoundImg-LTI.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./RoundImg-LTI.vue?vue&type=style&index=0&id=2fd775fc&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__